export const overAdvanceEn = {
  OVER_ADVANCE_CREATED_SUCCESSFULLY: 'Over Advance created successfully',
  FLAT_FEE: 'Flat fee',
  AMORTIZATION: 'Amortization',
  INTEREST_RATE: 'Interest Rate (%)',
  BATCH_RECOVERY_RATE: 'Batch Recovery Rate',
  BATCH_RECOVERY_RATE_TOOLTIP:
    'Autocalculates the chargeback amount from the total invoice amount. ($ Invoice Amount x Recovery Rate %)',
  PAYMENT_PLAN: 'Payment Plan',
  PAYMENT_FREQUENCY: 'Frequency',
  NUMBER_OF_PAYMENTS: 'Number of Payments',
  PAYMENT_START: 'Payment Start',
  FIXED_DATE: 'Fixed Date',
  FUNDING_DATE: 'Funding Date',
  PAYMENT_START_DATE: 'Payment Start Date',
  AMORTIZATION_SCHEDULE: 'Amortization Schedule',
  PAYMENT_NUMBER: '#',
  PAYMENT_DATE: 'Payment Date',
  PAYMENT_AMOUNT: 'Payment Amount',
  PAYMENT_INTEREST: 'Interest',
  PAYMENT_PRINCIPAL: 'Principal',
  PAYMENT_BALANCE: 'Balance',
  TBD_DATE: 'TBD',
  WEEKLY: 'Weekly',
  OVER_ADVANCE_AMOUNT: 'Over Advance Amount',
  OVER_ADVANCE_FEE: 'Fee Amount',
  OVER_ADVANCE_ZERO_INTEREST_WARNING:
    'Interest rate is 0. Amortization schedule will show zero interest.',
  OVER_ADVANCE_NOTES_UPDATED_SUCCESSFULLY: 'Over Advance notes updated successfully',
  OVER_ADVANCE_UPDATED_SUCCESSFULLY: 'Over Advance updated successfully',
  TOTAL_ADVANCE_AMT: 'Total Advance Amt',
  TOTAL_PAID: 'Total Paid',
  TOTAL_OVERALL_BALANCE: 'Total Overall Balance',
  TOTAL_OVER_ADVANCE_AMOUNT: 'Total Over Advance Amount',
  OVER_ADVANCE_BALANCE: 'Over Advance Balance',
  INTEREST_BALANCE: 'Interest Balance',
  MAX_100: 'Max 100',
  MAX_4_DECIMAL_PLACES: 'Max 4 decimal places',
  MAX_50_CHARACTERS: 'Maximum 50 characters allowed',
  OA_REFERENCE_NUMBER_BLANK: 'The reference number cannot be only spaces',
  SELECTED_OVER_ADVANCES: 'Selected Over Advances',
  CLICK_SELECTED_OVER_ADVANCE_TO_VIEW_INFORMATION: 'Click the selected Over Advance to view information',
  NO_NOTES_REGISTERED_FOR_THIS_OVER_ADVANCE: 'No notes recorded for this Over Advance.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_TITLE: 'Confirm Approval?',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_BODY: 'all these over advances will be approved for funding once submitted.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_ALL:
    '{count} over advances will be approved for funding once submitted.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_GO_BACK: 'Go back',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_APPROVE: 'Yes, Approve',
  DOCUMENTS_OVER_ADVANCE_UPLOADED_SUCCESSFULLY: 'Documents for Over Advance uploaded successfully',
  PLANNED_PAYMENT_UPDATED_SUCCESSFULLY: 'Payment updated successfully',
  PAYMENT_STATUS: 'Status',
  PAYMENT_STATUS_PAID: 'Paid',
  PAYMENT_STATUS_PENDING: 'Pending',
  EDIT_PAYMENT: 'Edit Payment',
  // Over Advance Templates
  OVER_ADVANCE_TEMPLATES: 'Over Advance Templates',
  OVER_ADVANCE_TEMPLATE: 'Over Advance Template',
  CREATE_OVER_ADVANCE_TEMPLATE: 'Create Over Advance Template',
  UPDATE_OVER_ADVANCE_TEMPLATE: 'Update Over Advance Template',
  OVER_ADVANCE_TEMPLATE_CREATED_SUCCESSFULLY: 'Over advance template created successfully',
  OVER_ADVANCE_TEMPLATE_UPDATED_SUCCESSFULLY: 'Over advance template updated successfully',
  DAILY: 'Daily',
  MONTHLY: 'Monthly',
  MANAGE_TEMPLATES: 'Manage Templates',
  BACK: 'Back',
  SELECT_TEMPLATE: 'Select Template (Optional)',
  NO_TEMPLATES_AVAILABLE: 'No templates available',
  REGENERATE_PAYMENT_PLAN: 'Regenerate Payment Plan',
  PAYMENT_PLAN_REGENERATED_SUCCESSFULLY: 'Payment plan regenerated successfully',
  CREATED_ON: 'Created On',
  FUNDED_DATE: 'Funded Date',
  // Write Off Over Advances
  WRITE_OFF_OA_NONE_SELECTED: 'No over advances selected',
  WRITE_OFF_OA_ONE_SELECTED: 'One over advance selected',
  WRITE_OFF_OA_MULTIPLE_SELECTED: '{amount} over advances selected',
  WRITE_OFF_OA_SUCCESS: 'Over advance write off applied successfully',
  WRITE_OFF_OA_CONFIRMATION: 'Are you sure that you want to apply this write off to these over advances?',
  WRITE_OFF_OA_TOTAL_BALANCE: 'Total OA Balance:',
  WRITE_OFF_OA_TOTAL_PAYOFF: 'Total payoff:',
  WRITE_OFF_OA_TOTAL_AMOUNT: 'Total Write Off Amount:',
  WRITE_OFF_OA_OVER_AMOUNT: 'The total write off amount exceeds the total over advance balance.',
  WRITE_OFF_OA_AMOUNT_POSITIVE: 'The write off amount must be greater than 0.',
  WRITE_OFF_OA_PERMISSION_REQUIRED: 'You do not have permission to write off over advances.',
  WRITE_OFF_OA_VALIDATION_MAX: 'Amount must be equal or less than the over advance balance.',
  APPLIED_OVER_ADVANCES: 'Applied Over Advances',
  PARTIAL: 'Partial',
  // Open Balance
  OPEN_BALANCE: 'Open balance',
  OA_INTEREST_SETTINGS: 'Interest settings',
  OA_RATE_TYPE: 'Rate type',
  OA_RATE_TYPE_FIXED: 'Fixed',
  OA_RATE_TYPE_PRIME_PLUS: 'Prime +',
  OA_RATE_TYPE_SOFR_PLUS: 'SOFR +',
  OA_RATE_TYPE_LIBOR_PLUS: 'LIBOR +',
  OA_ANNUAL_RATE: 'Annual rate (%)',
  OA_ANNUAL_SPREAD: 'Annual spread over base rate (%)',
  OA_ANNUAL_RATE_NOTICE: 'This rate is annual. It is not a rate per payment period.',
  OA_MINIMUM_RATE: 'Minimum rate (%)',
  OA_DAYS_PER_YEAR: 'Days per year',
  OA_CHARGE_FREQUENCY: 'Charge frequency',
  OA_INTEREST_METHOD: 'Interest method',
  OA_INTEREST_SIMPLE: 'Simple',
  OA_INTEREST_COMPOUND: 'Compound',
  OA_MAXIMUM_BALANCE: 'Maximum balance (optional)',
  OA_MAXIMUM_BALANCE_LABEL: 'Maximum balance',
  OA_AT_ZERO: 'At $0',
  OA_CLOSE_AT_ZERO: 'Close at $0',
  OA_STAY_OPEN: 'Stay open as a line of credit',
  OA_PRINCIPAL_OWED: 'Principal owed',
  OA_INTEREST_OWED: 'Interest owed',
  OA_BALANCE_OWED: 'Balance owed',
  OA_INTEREST_NOT_YET_CHARGED: 'Interest this period, not yet charged',
  OA_PAYOFF_AMOUNT: 'Payoff amount',
  OA_SETUP_LOCKED_NOTICE: 'Setup fields cannot be edited once the over advance leaves Pending.',
  OA_TEMPLATE_OVERWRITE_TITLE: 'Overwrite your changes?',
  OA_TEMPLATE_OVERWRITE_BODY:
    'Applying this template will replace the values you already entered in these fields. Cancel to keep your values.',
  OA_TEMPLATE_OVERWRITE_APPLY: 'Apply template',
  OA_TEMPLATE_TYPE_LOCKED_NOTICE: 'The type cannot be changed after the template is created.',
  OA_TEMPLATE_TYPE: 'Template type',
  OA_CLOSE: 'Close',
  OA_CLOSE_CONFIRMATION_TITLE: 'Close over advance',
  OA_CLOSE_CONFIRMATION_BODY: 'This over advance has no balance left and stays open as a line of credit. Close it now?',
  OA_CLOSE_SUCCESS: 'Over advance closed',
  OA_PAYOFF_LABEL: 'Payoff',
  OA_PAYOFF_TOOLTIP: 'Includes {amount} of interest calculated and not yet charged',
  OA_PAYOFF_LOADING: 'Loading payoff...',
  OA_PAYOFF_ERROR: 'The payoff could not be loaded',
  OA_PAYOFF_RETRY: 'Retry',
  OA_WRITE_OFF_BREAKDOWN_PRINCIPAL: 'Principal',
  OA_WRITE_OFF_BREAKDOWN_INTEREST_CHARGED: 'Interest charged',
  OA_WRITE_OFF_BREAKDOWN_INTEREST_NOT_YET_CHARGED: 'Interest not yet charged',
  OA_WRITE_OFF_FULL_PAYOFF_NOTICE: 'An Open Balance over advance is written off for its whole payoff.',
  OA_DRAWS: 'Draws',
  OA_ADD_DRAW: 'Add draw',
  OA_DRAW_NUMBER: 'Draw',
  OA_DRAW_AMOUNT: 'Draw amount',
  OA_NO_DRAWS: 'No draws yet',
  OA_DRAW_STATUS_PENDING: 'Pending',
  OA_DRAW_STATUS_APPROVED: 'Approved',
  OA_DRAW_STATUS_FUNDED: 'Funded',
  OA_DRAW_STATUS_CANCELLED: 'Cancelled',
  OA_DRAW_CREATED_SUCCESSFULLY: 'Draw created successfully',
  OA_DRAW_CANCELLED_SUCCESSFULLY: 'Draw cancelled successfully',
  OA_DRAW_CANCEL_CONFIRMATION: 'Cancel this draw? This cannot be undone.',
  OA_DRAW_CANCEL_CONFIRM: 'Cancel draw',
  OA_DRAW_APPROVE_FOR_FUNDING: 'Approve for Funding',
  OA_DRAW_APPROVE_CONFIRMATION_BODY: 'the draw will be approved for funding once submitted.',
  OA_DRAWS_LOAD_ERROR: 'The draws could not be loaded.',
  OA_DRAWS_PAYOFF_CANCEL_WARNING: 'Paying off will cancel {pending} pending draw(s).',
  OA_DRAWS_PAYOFF_KEPT_OPEN_WARNING: '{approved} approved draw(s) keep the over advance open at $0.',
  OA_DRAWS_AFFECTED: 'Draws involved',
  OA_DRAWS_UNAVAILABLE_WARNING:
    'The draws of this over advance could not be checked. Its pending draws are cancelled if it closes.',
  OA_DRAWS_AND_MORE: 'and {count} more',
  OA_DRAWS_CLOSE_WARNING:
    'Closing will cancel {pending} pending draw(s). An over advance with approved draws ({approved}) cannot be closed.',
  OA_DRAWS_WRITE_OFF_WARNING:
    'Writing off will cancel {pending} pending draw(s). Over advances with approved draws ({approved}) cannot be written off.',
  EXPORT_OVER_ADVANCES: 'Export Over Advances',
  ARE_YOU_SURE_EXPORT_OVER_ADVANCES: 'Are you sure you want to export the over advances?',
  EXPORT_OVER_ADVANCES_SUCCESSFULLY: 'Over advances exported successfully',
}

export const overAdvanceEs: typeof overAdvanceEn = {
  OVER_ADVANCE_CREATED_SUCCESSFULLY: 'Over Advance creado con éxito',
  FLAT_FEE: 'Tarifa fija',
  AMORTIZATION: 'Amortización',
  INTEREST_RATE: 'Tasa de Interés (%)',
  BATCH_RECOVERY_RATE: 'Tasa de Recuperación del Lote',
  BATCH_RECOVERY_RATE_TOOLTIP:
    'Calcula automáticamente el monto del chargeback a partir del monto total de la factura. ($ Monto de Factura x Tasa de Recuperación %)',
  PAYMENT_PLAN: 'Plan de Pago',
  PAYMENT_FREQUENCY: 'Frecuencia',
  NUMBER_OF_PAYMENTS: 'Número de Pagos',
  PAYMENT_START: 'Inicio de Pagos',
  FIXED_DATE: 'Fecha Fija',
  FUNDING_DATE: 'Fecha de Fondeo',
  PAYMENT_START_DATE: 'Fecha de Inicio',
  AMORTIZATION_SCHEDULE: 'Tabla de Amortización',
  PAYMENT_NUMBER: '#',
  PAYMENT_DATE: 'Fecha de Pago',
  PAYMENT_AMOUNT: 'Monto de Pago',
  PAYMENT_INTEREST: 'Interés',
  PAYMENT_PRINCIPAL: 'Capital',
  PAYMENT_BALANCE: 'Saldo',
  TBD_DATE: 'Por definir',
  WEEKLY: 'Semanal',
  OVER_ADVANCE_AMOUNT: 'Monto de Over Advance',
  OVER_ADVANCE_FEE: 'Monto de la tarifa',
  OVER_ADVANCE_ZERO_INTEREST_WARNING:
    'La tasa de interés es 0. La tabla de amortización mostrará interés 0.',
  OVER_ADVANCE_NOTES_UPDATED_SUCCESSFULLY: 'Notas de Over Advance actualizadas con éxito',
  OVER_ADVANCE_UPDATED_SUCCESSFULLY: 'Over Advance actualizado con éxito',
  TOTAL_ADVANCE_AMT: 'Monto total del adelanto',
  TOTAL_PAID: 'Total pagado',
  TOTAL_OVERALL_BALANCE: 'Saldo total general',
  TOTAL_OVER_ADVANCE_AMOUNT: 'Monto total de Over Advance',
  OVER_ADVANCE_BALANCE: 'Saldo de Over Advance',
  INTEREST_BALANCE: 'Saldo de interés',
  MAX_100: 'Máximo 100',
  MAX_4_DECIMAL_PLACES: 'Máximo 4 decimales',
  MAX_50_CHARACTERS: 'Máximo 50 caracteres permitidos',
  OA_REFERENCE_NUMBER_BLANK: 'El número de referencia no puede contener solo espacios',
  SELECTED_OVER_ADVANCES: 'Over Advances seleccionados',
  CLICK_SELECTED_OVER_ADVANCE_TO_VIEW_INFORMATION: 'Haz clic en un Over Advance para ver su información',
  NO_NOTES_REGISTERED_FOR_THIS_OVER_ADVANCE: 'No hay notas registradas para este Over Advance.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_TITLE: '¿Confirmar aprobación?',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_BODY:
    'todos estos over advances serán aprobados para financiamiento una vez enviados.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_ALL:
    '{count} over advances serán aprobados para financiamiento una vez enviados.',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_GO_BACK: 'Regresar',
  APPROVE_FOR_FUNDING_OVER_ADVANCE_CONFIRMATION_APPROVE: 'Sí, aprobar',
  DOCUMENTS_OVER_ADVANCE_UPLOADED_SUCCESSFULLY: 'Documentos para Over Advance cargados correctamente',
  PLANNED_PAYMENT_UPDATED_SUCCESSFULLY: 'Pago actualizado correctamente',
  PAYMENT_STATUS: 'Estado',
  PAYMENT_STATUS_PAID: 'Pagado',
  PAYMENT_STATUS_PENDING: 'Pendiente',
  EDIT_PAYMENT: 'Editar Pago',
  // Over Advance Templates
  OVER_ADVANCE_TEMPLATES: 'Plantillas de Over Advance',
  OVER_ADVANCE_TEMPLATE: 'Plantilla de Over Advance',
  CREATE_OVER_ADVANCE_TEMPLATE: 'Crear Plantilla de Over Advance',
  UPDATE_OVER_ADVANCE_TEMPLATE: 'Actualizar Plantilla de Over Advance',
  OVER_ADVANCE_TEMPLATE_CREATED_SUCCESSFULLY: 'Plantilla de Over Advance creada con éxito',
  OVER_ADVANCE_TEMPLATE_UPDATED_SUCCESSFULLY: 'Plantilla de Over Advance actualizada con éxito',
  DAILY: 'Diario',
  MONTHLY: 'Mensual',
  MANAGE_TEMPLATES: 'Administrar Plantillas',
  BACK: 'Regresar',
  SELECT_TEMPLATE: 'Seleccionar Plantilla (Opcional)',
  NO_TEMPLATES_AVAILABLE: 'No hay plantillas disponibles',
  REGENERATE_PAYMENT_PLAN: 'Regenerar Plan de Pago',
  PAYMENT_PLAN_REGENERATED_SUCCESSFULLY: 'Plan de pago regenerado con éxito',
  CREATED_ON: 'Fecha de Creación',
  FUNDED_DATE: 'Fecha de Fondeo',
  // Write Off Over Advances
  WRITE_OFF_OA_NONE_SELECTED: 'Ningún over advance seleccionado',
  WRITE_OFF_OA_ONE_SELECTED: 'Un over advance seleccionado',
  WRITE_OFF_OA_MULTIPLE_SELECTED: '{amount} over advances seleccionados',
  WRITE_OFF_OA_SUCCESS: 'Write off de over advance aplicado correctamente',
  WRITE_OFF_OA_CONFIRMATION: '¿Está seguro que desea aplicar este Write Off a estos over advances?',
  WRITE_OFF_OA_TOTAL_BALANCE: 'Saldo total OA:',
  WRITE_OFF_OA_TOTAL_PAYOFF: 'Total de liquidación:',
  WRITE_OFF_OA_TOTAL_AMOUNT: 'Monto total de Write Off:',
  WRITE_OFF_OA_OVER_AMOUNT: 'El monto total del write off excede el saldo total del over advance.',
  WRITE_OFF_OA_AMOUNT_POSITIVE: 'El monto del write off debe ser mayor a 0.',
  WRITE_OFF_OA_PERMISSION_REQUIRED: 'No tienes permiso para aplicar write offs a over advances.',
  WRITE_OFF_OA_VALIDATION_MAX: 'El monto debe ser igual o menor al saldo del over advance.',
  APPLIED_OVER_ADVANCES: 'Over Advances aplicados',
  PARTIAL: 'Parcial',
  // Open Balance
  OPEN_BALANCE: 'Saldo abierto',
  OA_INTEREST_SETTINGS: 'Configuración de interés',
  OA_RATE_TYPE: 'Tipo de tasa',
  OA_RATE_TYPE_FIXED: 'Fija',
  OA_RATE_TYPE_PRIME_PLUS: 'Prime +',
  OA_RATE_TYPE_SOFR_PLUS: 'SOFR +',
  OA_RATE_TYPE_LIBOR_PLUS: 'LIBOR +',
  OA_ANNUAL_RATE: 'Tasa anual (%)',
  OA_ANNUAL_SPREAD: 'Diferencial anual sobre la tasa base (%)',
  OA_ANNUAL_RATE_NOTICE: 'Esta tasa es anual. No es una tasa por periodo de pago.',
  OA_MINIMUM_RATE: 'Tasa mínima (%)',
  OA_DAYS_PER_YEAR: 'Días por año',
  OA_CHARGE_FREQUENCY: 'Frecuencia de cargo',
  OA_INTEREST_METHOD: 'Método de interés',
  OA_INTEREST_SIMPLE: 'Simple',
  OA_INTEREST_COMPOUND: 'Compuesto',
  OA_MAXIMUM_BALANCE: 'Saldo máximo (opcional)',
  OA_MAXIMUM_BALANCE_LABEL: 'Saldo máximo',
  OA_AT_ZERO: 'Al llegar a $0',
  OA_CLOSE_AT_ZERO: 'Cerrar en $0',
  OA_STAY_OPEN: 'Mantener abierto como línea de crédito',
  OA_PRINCIPAL_OWED: 'Capital adeudado',
  OA_INTEREST_OWED: 'Interés adeudado',
  OA_BALANCE_OWED: 'Saldo adeudado',
  OA_INTEREST_NOT_YET_CHARGED: 'Interés del periodo, aún no cargado',
  OA_PAYOFF_AMOUNT: 'Monto de liquidación',
  OA_SETUP_LOCKED_NOTICE: 'Los campos de configuración no se pueden editar cuando el over advance sale de Pendiente.',
  OA_TEMPLATE_OVERWRITE_TITLE: '¿Sobrescribir tus cambios?',
  OA_TEMPLATE_OVERWRITE_BODY:
    'Al aplicar esta plantilla se reemplazarán los valores que ya ingresaste en estos campos. Cancela para conservar tus valores.',
  OA_TEMPLATE_OVERWRITE_APPLY: 'Aplicar plantilla',
  OA_TEMPLATE_TYPE_LOCKED_NOTICE: 'El tipo no se puede cambiar después de crear la plantilla.',
  OA_TEMPLATE_TYPE: 'Tipo de plantilla',
  OA_CLOSE: 'Cerrar',
  OA_CLOSE_CONFIRMATION_TITLE: 'Cerrar over advance',
  OA_CLOSE_CONFIRMATION_BODY: 'Este over advance no tiene saldo y sigue abierto como línea de crédito. ¿Cerrarlo ahora?',
  OA_CLOSE_SUCCESS: 'Over advance cerrado',
  OA_PAYOFF_LABEL: 'Liquidación',
  OA_PAYOFF_TOOLTIP: 'Incluye {amount} de interés calculado y aún no cargado',
  OA_PAYOFF_LOADING: 'Cargando liquidación...',
  OA_PAYOFF_ERROR: 'No se pudo cargar la liquidación',
  OA_PAYOFF_RETRY: 'Reintentar',
  OA_WRITE_OFF_BREAKDOWN_PRINCIPAL: 'Principal',
  OA_WRITE_OFF_BREAKDOWN_INTEREST_CHARGED: 'Interés cargado',
  OA_WRITE_OFF_BREAKDOWN_INTEREST_NOT_YET_CHARGED: 'Interés aún no cargado',
  OA_WRITE_OFF_FULL_PAYOFF_NOTICE: 'Un over advance Open Balance se castiga por todo su monto de liquidación.',
  OA_DRAWS: 'Draws',
  OA_ADD_DRAW: 'Agregar draw',
  OA_DRAW_NUMBER: 'Draw',
  OA_DRAW_AMOUNT: 'Monto del draw',
  OA_NO_DRAWS: 'Aún no hay draws',
  OA_DRAW_STATUS_PENDING: 'Pendiente',
  OA_DRAW_STATUS_APPROVED: 'Aprobado',
  OA_DRAW_STATUS_FUNDED: 'Fondeado',
  OA_DRAW_STATUS_CANCELLED: 'Cancelado',
  OA_DRAW_CREATED_SUCCESSFULLY: 'Draw creado con éxito',
  OA_DRAW_CANCELLED_SUCCESSFULLY: 'Draw cancelado con éxito',
  OA_DRAW_CANCEL_CONFIRMATION: '¿Cancelar este draw? Esta acción no se puede deshacer.',
  OA_DRAW_CANCEL_CONFIRM: 'Cancelar draw',
  OA_DRAW_APPROVE_FOR_FUNDING: 'Aprobar para fondeo',
  OA_DRAW_APPROVE_CONFIRMATION_BODY: 'el draw se aprobará para fondeo una vez enviado.',
  OA_DRAWS_LOAD_ERROR: 'No se pudieron cargar los draws.',
  OA_DRAWS_PAYOFF_CANCEL_WARNING: 'Liquidar cancelará {pending} draw(s) pendiente(s).',
  OA_DRAWS_PAYOFF_KEPT_OPEN_WARNING: '{approved} draw(s) aprobado(s) mantienen el over advance abierto en $0.',
  OA_DRAWS_AFFECTED: 'Draws involucrados',
  OA_DRAWS_UNAVAILABLE_WARNING:
    'No se pudieron verificar los draws de este over advance. Sus draws pendientes se cancelan si se cierra.',
  OA_DRAWS_AND_MORE: 'y {count} más',
  OA_DRAWS_CLOSE_WARNING:
    'Cerrar cancelará {pending} draw(s) pendiente(s). Un over advance con draws aprobados ({approved}) no se puede cerrar.',
  OA_DRAWS_WRITE_OFF_WARNING:
    'Castigar cancelará {pending} draw(s) pendiente(s). Los over advances con draws aprobados ({approved}) no se pueden castigar.',
  EXPORT_OVER_ADVANCES: 'Exportar Over Advances',
  ARE_YOU_SURE_EXPORT_OVER_ADVANCES: '¿Está seguro de que desea exportar los over advances?',
  EXPORT_OVER_ADVANCES_SUCCESSFULLY: 'Over advances exportados exitosamente',
}
